export enum Modules {
  Agency = 'agency',
  BusinessSettings = 'businessSettings',
  LocationDashboard = 'locationDashboard',
  PipelineSettings = 'pipelineSettings',
  AgentReporting = 'agentReporting',
  Reputation = 'reputation',
  AdReporting = 'adReporting',
  Blogs = 'blogs',
  AppointmentReporting = 'apptReporting',
  Eliza = 'eliza',
  Launchpad = 'launchpad'
}
